import { render, staticRenderFns } from "./titleForm.vue?vue&type=template&id=2b25a69d&"
import script from "./titleForm.vue?vue&type=script&lang=js&"
export * from "./titleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b25a69d')) {
      api.createRecord('2b25a69d', component.options)
    } else {
      api.reload('2b25a69d', component.options)
    }
    module.hot.accept("./titleForm.vue?vue&type=template&id=2b25a69d&", function () {
      api.rerender('2b25a69d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/titleForm.vue"
export default component.exports